var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorialIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#3951A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 14.0741 33.2609 11.3209 31.9591 8.9169C28.9703 6.30508 25.0588 4.72266 20.7778 4.72266C11.389 4.72266 3.77783 12.3338 3.77783 21.7227C3.77783 24.6485 4.51698 27.4017 5.81874 29.8058C8.80756 32.4176 12.719 34 17 34Z",
    fill: "#4A60AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15784_9955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 14.332C12.8639 14.332 13.3726 14.1213 13.7477 13.7462C14.1228 13.3712 14.3335 12.8625 14.3335 12.332C14.3335 11.8016 14.1228 11.2929 13.7477 10.9178C13.3726 10.5427 12.8639 10.332 12.3335 10.332C11.8031 10.332 11.2944 10.5427 10.9193 10.9178C10.5442 11.2929 10.3335 11.8016 10.3335 12.332C10.3335 12.8625 10.5442 13.3712 10.9193 13.7462C11.2944 14.1213 11.8031 14.332 12.3335 14.332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0945 13.902C10.8028 14.4571 10.5914 15.0508 10.4668 15.6654M13.9035 11.093C14.4585 10.8014 15.0523 10.59 15.6668 10.4654M21.6668 14.332C22.1972 14.332 22.7059 14.1213 23.081 13.7462C23.4561 13.3712 23.6668 12.8625 23.6668 12.332C23.6668 11.8016 23.4561 11.2929 23.081 10.9178C22.7059 10.5427 22.1972 10.332 21.6668 10.332C21.1364 10.332 20.6277 10.5427 20.2526 10.9178C19.8775 11.2929 19.6668 11.8016 19.6668 12.332C19.6668 12.8625 19.8775 13.3712 20.2526 13.7462C20.6277 14.1213 21.1364 14.332 21.6668 14.332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0968 11.0925C19.5417 10.8008 18.948 10.5895 18.3335 10.4648M22.9055 13.9015C23.1973 14.4566 23.4087 15.0503 23.5335 15.6648M21.6668 23.6648C22.1973 23.6648 22.706 23.4541 23.081 23.0791C23.4561 22.704 23.6668 22.1953 23.6668 21.6648C23.6668 21.1344 23.4561 20.6257 23.081 20.2506C22.706 19.8756 22.1973 19.6648 21.6668 19.6648C21.1364 19.6648 20.6277 19.8756 20.2526 20.2506C19.8775 20.6257 19.6668 21.1344 19.6668 21.6648C19.6668 22.1953 19.8775 22.704 20.2526 23.0791C20.6277 23.4541 21.1364 23.6648 21.6668 23.6648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9055 20.0954C23.1973 19.5403 23.4087 18.9466 23.5335 18.332M20.0968 22.904C19.5418 23.1958 18.9481 23.4073 18.3335 23.532M12.3335 23.6654C12.8639 23.6654 13.3726 23.4547 13.7477 23.0796C14.1228 22.7045 14.3335 22.1958 14.3335 21.6654C14.3335 21.1349 14.1228 20.6262 13.7477 20.2512C13.3726 19.8761 12.8639 19.6654 12.3335 19.6654C11.8031 19.6654 11.2944 19.8761 10.9193 20.2512C10.5442 20.6262 10.3335 21.1349 10.3335 21.6654C10.3335 22.1958 10.5442 22.7045 10.9193 23.0796C11.2944 23.4547 11.8031 23.6654 12.3335 23.6654Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9035 22.9053C14.4585 23.1971 15.0522 23.4086 15.6668 23.5333M11.0945 20.0967C10.8028 19.5416 10.5915 18.9479 10.4668 18.3333M17.0001 19V15M15.0001 17H19.0001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15784_9955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon3);
export default __webpack_public_path__ + "static/media/tutorialIcon3.9a2999883b6a12cfef989f53a5b6ea73.svg";
export { ForwardRef as ReactComponent };